import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import { Link, useLocation, useParams } from "react-router-dom";
// import DyanamicRoutes from "routes/dynamicRoutes";
import "../../../assets/css/cms/Products.css";
import loadable from "@loadable/component";
import Loading from "../../utils/loader";
import { useSelector } from "react-redux";
import PermissionDenied from "../common/permissionDenied";
import { connect } from "react-redux";

const FilterList = loadable(() => import("./filterList"), {
  fallback: () => <Loading />,
});


function DomainMapping(props) {
    const router = useLocation();
    const { param } = useParams();
    let relatedPath = router.pathname.split("/add-edit")[0];
    const [activeComponent, setActiveComponent] = useState();
    const { userPermission } = useSelector((state) => {
        return state.userData;
    });

    // checking permission to show tabs
    const findPermission = (application, action) => {
        let authorized = false;
        const userPermissions = userPermission?.data;
        if (userPermissions) {
            authorized = userPermissions.some(permission => {
                return permission.content_type === application && permission.name === action
            });
        }
        return authorized;
    }

    let ROUTES = [
        { path: "", 
          exact: true, 
          value: "", 
          element: <FilterList /> 
        },
    ];
    
    useEffect(() => {
        if (param) {
            let activeComponent = ROUTES.find((obj) => {
                if (obj.path == param) {
                    return obj;
                }
            });
            if (activeComponent && activeComponent?.application && activeComponent?.action && !findPermission(activeComponent?.application, activeComponent?.action)) {
                setActiveComponent(<PermissionDenied />)
            }
            else {
                setActiveComponent(activeComponent?.element);
            }
        } else {
            setActiveComponent(ROUTES[0].element);
        }
    }, [param]);

    return (
        <div>
            <div className={"nav_container"}>
                <Nav className={"sub_nav"}>
                    <Nav.Item
                        className={`${relatedPath == "/cms/whatsapp-mapping" ||
                            router.pathname == "/cms/whatsapp-mapping"
                            ? "nav_links_active"
                            : ""
                            }`}
                    >
                        <Nav.Link>
                            {" "}
                            <Link to="/cms/whatsapp-mapping">WA URL Mapping</Link>
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </div>
            {/* <DyanamicRoutes {...props} /> */}
            {activeComponent}
        </div>
    );
}
const mapStateToProps = (state) => {
    return {
      _user_permission: state.userData?.userPermission,
    };
  };
  

export default connect(mapStateToProps) (DomainMapping);